<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- 16-grid icon: stroke 0.8 here matches the standard 1.2 of the
         24-grid icons (same rendered thickness at equal display size). -->
    <path
      d="M9.333 1.333H4a1.333 1.333 0 0 0-1.333 1.334v10.666A1.333 1.333 0 0 0 4 14.667h8a1.333 1.333 0 0 0 1.333-1.334V5.333l-4-4Z"
      class="stroke"
      stroke-width="0.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.333 1.333v4h4"
      class="stroke"
      stroke-width="0.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({ name: "FileIcon" });
</script>

<style scoped lang="scss">
@use "@/components/icons/icon.scss";
</style>
